import AlertDialog from "common/AlertDialog";
import moment from "moment";
import { useEffect, useState } from "react";
import { withAlert } from "react-alert";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import {
  profileAddEvent,
  updateProfileCompletness,
} from "redux-helpers/ActionCreator";
import { CommonServices } from "utils/CommonServices";
import { UserStatusConstants } from "utils/Constants";
import {
  convertToMMMYYYYFormat,
  dateDifferenceInYearsAndMonths,
  getEmptySectionShowHide,
  getFullAddress,
  makeFullNameWithAddressWhenAddressIsNested,
  renderDateRange,
} from "utils/Utils";
import { RenderCommitteModal } from "./components/RenderCommitteModal";
import pannel_arrow from "assets/svgIcon/down-arrow-white-icon.svg";
import committiees_icon from "assets/svgIcon/committiees_icon.svg";
import plusIcon from "assets/images/plus-icon-lg.png";
import edit_blue_icon from "assets/images/edit-blue-icon.png";
import del_red_icon from "assets/images/del-red-icon.png";
import NoData from "../NoData";

const RenderCommittee = (props) => {
  const {
    isAdmin,
    committee,
    handleEditItem,
    handleRemoveItem,
    isLoggedinUser,
  } = props;
  const currentUser = useSelector((state) => state.auth.currentUser);
  if (committee && committee.length > 0) {
    return committee.map((item, index) => {
      const { startedOn, endedOn, doesNotExpire } = item;
      const profileIdLink = item?.institutionDetail?.profileId
        ? item?.institutionDetail?.profileId
        : item?.institutionDetail?.guid;
      const committeeName = item.name ? item.name : "";
      const institutionName = getFullAddress({
        name: item?.institutionDetail?.name ?? "",
        abbreviation: item?.institutionDetail?.abbreviation ?? "",
        location: item?.institutionDetail?.address?.location ?? "",
        city: item?.institutionDetail?.address?.city ?? "",
        state: item?.institutionDetail?.address?.state ?? "",
      });
      item.startYear = item?.startedOn ?? "";
      item.endYear = item?.endedOn ?? "";
      item.committeeName = item?.name ?? "";
      item.currentMember = item?.doesNotExpire === true;
      if (item?.institutionDetail?.guid) {
        item.institutionDetail = {
          guid: item?.institutionDetail?.guid,
          name: item?.institutionDetail?.name,
          institutionName: item?.institutionDetail ? makeFullNameWithAddressWhenAddressIsNested(item?.institutionDetail) : "",
          ...(item?.institutionDetail?.abbreviation && {
            abbreviation: item?.institutionDetail?.abbreviation,
          }),
          ...(item?.institutionDetail?.address && {
            address: item?.institutionDetail?.address,
          }),
          onSelectNewInstitutionCollege: 1,
        };
      }
      return (
        <li
          className="list-group-item"
          key={`committee_${item.guid}`}
        >
          <div className="row g-0">
            <div className="col-auto">
              <img src={committiees_icon} alt="" />
            </div>

            <div className="col">
              <h3 className="card-title">{committeeName} {" - "} {item.positionHeld ? item.positionHeld : null}</h3>
              <p className="card-title mb-0"><small className="text-muted fw-semibold"><Link
                to={`/institution/${profileIdLink}`}
                className=""
              >{institutionName}</Link></small></p>

              {item?.startedOn &&
                <p className="card-text">
                  <small className="text-muted"><span>{" Member Since: "}</span>
                    <span>
                      <span>
                        {convertToMMMYYYYFormat(item?.startedOn)}{" - "}
                      </span>
                      <span>{item?.doesNotExpire ? <span><span> {"Present | "}</span><span>{dateDifferenceInYearsAndMonths(item?.startedOn)} </span> </span> : convertToMMMYYYYFormat(item?.endedOn)}</span>
                    </span>
                  </small>
                </p>}
            </div>



            {/** 
            <div className="flex-grow-1">
              <div className="d-flex">
                <div className="prize-icon badgeshape">
                  <img src={blackGroupIcon} width="16" alt="" />
                </div>
                <div className="ml-2">
                  <div className="section-item-shortdes  mb-2">
                    {committeeName}
                    {" - "}
                    {item.positionHeld ? item.positionHeld : null}
                  </div>
                  <Link
                    to={`/institution/${profileIdLink}`}
                    className="mb-2 d-block color-accent"
                  >
                    <h6 className="section-item-title item-blue-title f-12 m-0">
                      {institutionName}
                    </h6>
                  </Link>
                  <p className="text-gray f-14 font-weight-500 m-0">
                    {timeDuration}
                  </p>
                </div>
              </div>
            </div>
            */}



            <div className="col-auto d-flex align-items-start">
              {(isAdmin ||
                (isLoggedinUser &&
                  currentUser.status === UserStatusConstants.APPROVED)) && (
                  <div className="delete-action">
                    <Button
                      color="link"
                      className="visible-hover py-0 nex-cs-committees-edit-btn"
                      onClick={() => handleEditItem(item)}
                    >
                      <img src={edit_blue_icon} alt="" />
                    </Button>
                    <Button
                      color="link"
                      className="visible-hover delete py-0 nex-cs-committees-del-btn"
                      onClick={() => handleRemoveItem(item)}
                    >
                      <img src={del_red_icon} alt="" />
                    </Button>
                  </div>
                )}
            </div>
          </div>
        </li>
      );
    });
  } else {
    return null;
  }
};

const initialValue = {
  committeeName: "",
  institutionName: "",
  positionHeld: "",
  startYear: "",
  endYear: "",
  description: "",
  expires: false,
  currentMember: false,
  addressLine1: "",
  addressLine2: "",
  city: [],
  country: [],
  location: [],
  postalCode: "",
  state: [],
  category: "",
};

const Committees = (props) => {
  const [pannel_on, setPannel_on] = useState(true);
  const currentUser = useSelector((state) => state.auth.currentUser);
  const eventName = useSelector((state) => state.profileComplete.eventName);
  const dispatch = useDispatch();
  const userGUID = props.practitioner.guid;
  const { alert, isLoggedinUser, isAdmin, setShowCommitteesOnTabScroll } = props;
  const [committee, setCommittee] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});
  const [isOpen, setModal] = useState(false);
  const toggle = () => setModal(!isOpen);
  const [isOpenAlert, setAlertModal] = useState(false);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    dispatch(updateProfileCompletness(11, !!committee.length));

    if (committee.length > 0 || isLoggedinUser || isAdmin) {
      setShowCommitteesOnTabScroll(true);
    }else{
      setShowCommitteesOnTabScroll(false);
    }
  }, [committee]);

  useEffect(() => {
    if (eventName === "ADD_COMMITTEES") {
      handleEditItem(initialValue);
      dispatch(profileAddEvent(null));
    }
  }, [eventName]);

  const toggleAlert = () => {
    setLoading(false);
    setAlertModal(!isOpenAlert);
  };

  useEffect(() => {
    const getCommittees = async () => {
      getData();
    };
    getCommittees();
  }, [userGUID]);

  const handleEditItem = (selectedItem) => {
    setSelectedItem(selectedItem);
    toggle();
  };

  const handleRemoveItem = (selectedItem) => {
    setSelectedItem(selectedItem);
    toggleAlert();
  };

  const handleClickOnYes = async () => {
    setLoading(true);
    try {
      const response = CommonServices.deleteCommittee(
        selectedItem.guid,
        userGUID
      );
      response.then(
        (response) => {
          const { status } = response;
          if (status === 204) {
            setTimeout(() => {
              alert.success("Committee deleted successfully.");
              getData();
              setLoading(false);
              toggleAlert();
            }, 1000);
          } else {
            alert.error("Cannot delete committee.");
            setLoading(false);
            toggleAlert();
          }
        },
        (e) => {
          setLoading(false);
          console.log("error", e.message);
          let errmsg = e.message;
          if (e.response) {
            errmsg =
              e.response.data && !!e.response.data.message
                ? e.response.data.message
                : errmsg;
          }
          alert.error(errmsg);
        }
      );
    } catch (e) {
      alert.error(e.message);
      setLoading(false);
      toggleAlert();
    }
  };

  const getData = () => {
    const response = CommonServices.getCommittees(userGUID);
    response.then(
      (response) => {
        let { data } = response;
        if (data && data.length > 0) {
          setCommittee(
            data.map((node) => {
              const [fromMonth, fromYear] = node?.startedOn
                ? node?.startedOn.split("-")
                : "";
              const [toMonth, toYear] = node?.endedOn
                ? node?.endedOn.split("-")
                : "";
              return {
                ...node,
                fromMonth:
                  fromMonth && fromYear
                    ? moment(fromMonth + "/01/" + fromYear).format("MMMM")
                    : "",
                fromYear:
                  fromMonth && fromYear
                    ? moment(fromMonth + "/01/" + fromYear).format("YYYY")
                    : "",
                toMonth:
                  toMonth && toYear
                    ? moment(toMonth + "/01/" + toYear).format("MMMM")
                    : "",
                toYear:
                  toMonth && toYear
                    ? moment(toMonth + "/01/" + toYear).format("YYYY")
                    : "",
                toDate: node?.endYear ?? "",
              };
            })
          );
        } else {
          setCommittee([]);
        }
      },
      (error) => {
        console.log(error.message);
      }
    );
  };

  const globalProfileInfo = useSelector(
    (state) => state.GlobalProfileReducer.globalProfileInfo
  );

  if (
    getEmptySectionShowHide(
      committee ?? [],
      isAdmin,
      currentUser,
      globalProfileInfo,
      userGUID
    )
  )
    return null;

  return (
    <>
      <Card className={`card nexogic-card-color-header ${pannel_on ? 'expanded' : ''}`} id="committeesSection">
        <div className="card-header"><h2>Committees</h2>


          {(isAdmin ||
            (isLoggedinUser &&
              currentUser.status === UserStatusConstants.APPROVED)) && (
              <Button
                id="nex-cs-committees-add-btn"
                color="link"
                className="add-button"
                onClick={() => handleEditItem(initialValue)}
              >
                <img src={plusIcon} alt="" />
              </Button>
            )}
          <button className="collapse-btn" type="button" onClick={() => setPannel_on(!pannel_on)}>
            <img src={pannel_arrow} alt="" />
          </button>
        </div>
        <div className={`collapse-div`}>
          <CardBody className={
            committee && committee.length > 0
              ? ""
              : "align-items-center"
          }>
            {committee && committee.length
              ? ""
              : (isLoggedinUser || isAdmin) &&
              currentUser.status === UserStatusConstants.APPROVED && (
                <Button
                id="nex-cs-committees-add-btn2"
                  className="readmore"
                  color="link"
                  onClick={() => handleEditItem(initialValue)}
                >
                  {"Add committees"}
                </Button>
              )}
            {/** 
          <Row
            
          >
            <Col>
              <h3 className="section-title m-0 mb-3">Committees</h3>
              {committee && committee.length
                ? ""
                : (isLoggedinUser || isAdmin) &&
                  currentUser.status === UserStatusConstants.APPROVED && (
                    <div className="mt-3">
                      <Row className="align-items-center">
                        <Col className="add-infomation-part">
                          <Button
                            className="add-infomation p-0"
                            color="link"
                            onClick={() => handleEditItem(initialValue)}
                          >
                            {"Add committees"}
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  )}
            </Col>
            
          </Row>
          */}
            <ul className="list-group list-group-flush" id="nex-cs-committees-lists">

              <RenderCommittee
                committee={committee}
                handleEditItem={handleEditItem}
                handleRemoveItem={handleRemoveItem}
                isLoggedinUser={isLoggedinUser}
                isAdmin={isAdmin}
              />
            </ul>
            {committee.length < 1 && 
            <NoData>No Data</NoData>
            }
            <RenderCommitteModal
              selectedItem={selectedItem}
              toggle={toggle}
              isOpen={isOpen}
              userGUID={userGUID}
              getData={getData}
              isAdmin={isAdmin}
            />
            <AlertDialog
              toggle={toggleAlert}
              isOpen={isOpenAlert}
              isLoading={isLoading}
              handleClickOnYes={handleClickOnYes}
              yesLabel={"Yes"}
              noLabel={"No"}
            />
          </CardBody>
        </div>
      </Card>
    </>
  );
};

export default withAlert()(Committees);
